import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { LARGER_PICKER_WIDTH } from '../../utils/styled/dimensions';

export const Components = {
  Container: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 20px 16px;
    gap: 16px;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.radiuses.default};
    width: 100%;
  `,
  FieldWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    flex: 1;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.greys.prettyDark};
  `,
  TextFieldContainer: styled.div`
    width: 100%;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.default};
    background-color: ${AppCSS.colors.white};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-width: ${LARGER_PICKER_WIDTH}px;
    &:hover {
      border-color: ${AppCSS.colors.greys.prettyDark};
    }
    &:focus-within {
      border-color: ${AppCSS.colors.blues.primary};
      box-shadow: 0 0 0 3px ${AppCSS.colors.blues.primary}33;
    }
  `,
  TextField: styled.input`
    flex: 1;
    width: 100%;
    padding: 12px;
    height: 40px;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.blues.veryDark};
    background-color: transparent;
    border: none;
    -webkit-appearance: none;
    &:focus-visible {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &:focus {
      -webkit-appearance: none;
      border: none;
      outline: none;
    }
    &::placeholder {
      color: ${AppCSS.colors.greys.prettyDark};
      ${AppCSS.fonts.label14Regular};
    }
  `,
};
